import { WORKFLOW_QUERY } from '@/utils/constants';
import {
  isAccessGroupCreationConversation,
  isBulkUserImportConversation,
  isDeviceSetupConversation,
  isUserCreationConversation,
} from '@/utils/conversationWorkflow';

const GUIDED_WORKFLOW_VALUES = new Set<string>(Object.values(WORKFLOW_QUERY));

export function parseConversationIdFromPath(pathname: string): string | null {
  const segments = pathname.split('/').filter(Boolean);
  const conversationsIdx = segments.lastIndexOf('conversations');
  if (conversationsIdx === -1 || conversationsIdx >= segments.length - 1) return null;
  return segments[conversationsIdx + 1] ?? null;
}

/** True when the current route is a guided workflow conversation. */
export function isGuidedFlowRoute(pathname: string, search: string): boolean {
  const workflow = new URLSearchParams(search).get('workflow');
  if (workflow && GUIDED_WORKFLOW_VALUES.has(workflow)) return true;

  const conversationId = parseConversationIdFromPath(pathname);
  if (!conversationId) return false;

  return (
    isDeviceSetupConversation(conversationId) ||
    isUserCreationConversation(conversationId) ||
    isAccessGroupCreationConversation(conversationId) ||
    isBulkUserImportConversation(conversationId)
  );
}

/** True when the route is the bulk user import guided workflow (split-panel layout). */
export function isBulkUserImportRoute(pathname: string, search: string): boolean {
  const workflow = new URLSearchParams(search).get('workflow');
  if (workflow === WORKFLOW_QUERY.BULK_USER_IMPORT) return true;

  const conversationId = parseConversationIdFromPath(pathname);
  if (!conversationId) return false;

  return isBulkUserImportConversation(conversationId);
}
